import { isFunction } from 'lodash-es'

export default (imageFile, callBack) => {
  const reader = new FileReader()

  reader.onloadend = () => {
    if (isFunction(callBack)) {
      return callBack(imageFile, reader.result)
    }

    return reader.result
  }

  reader.readAsDataURL(imageFile.file)
}
